
export const VERSION = '5.6.0'; // Update this manually on each release


